import { SLowcodeList } from 'shj-components'
import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useActivate } from 'react-activation'
import { useParams } from 'react-router-dom'

import config from './config.tsx'
import { merchOverflowList } from '@/services/order.ts'

const ExcessiveDiscount = forwardRef((props: any, ref: any) => {
  const { id } = useParams()
  const listRef = useRef<any>()

  useActivate(() => {
    listRef.current?.reload()
  })
  useImperativeHandle(ref, () => {
    return {
      reload: () => listRef.current.reload(),
    }
  }, [listRef.current])
  
  const fetchList = (values: any) => {
    // const { current, pageSize, query } = values
    return new Promise((resolve, reject) => {
      try {
        merchOverflowList({ orderId: id })
          .then((res: any) => {
            resolve({ records: res || [], total: res?.length || 0 })
          })
          .catch(() => {
            reject({ success: false })
          })
      } catch {
        reject({ success: false })
      }
    })
  }
  const extensions = {
    request: { fetchList },
    events: { reload: () => listRef.current?.reset() },
  }

  return <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extensions} />
})

export default ExcessiveDiscount
